import {jwtDecode} from "jwt-decode";

const API_URL = 'https://dittmagasin.no/api/v2';

const authService = {
  login: async (credentials) => {
    try {
      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials)
      });
      return response;
    } catch (error) {
      return { message: 'Network error' };
    }
  },
  register: async (userData) => {
    try {
      const response = await fetch(`${API_URL}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': 'gd54m8auqgn7j3llo'
          // 'apikey': 'gd54m8auqgn7j3llo'
        },
        body: JSON.stringify({ ...userData, redirecturl: '', user_preferences: null })
      });

      return await response.json();
    } catch (error) {
      return { message: 'Network error' };
    }
  },
  getUserFromToken: async () => {
    const token = localStorage.getItem("token");
    if (!token) return null;

    try {
      const decoded = jwtDecode(token);
      return decoded; // Extract user info from token
    } catch (error) {
      return null;
    }
  },
};

export default authService;